import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ManageProhibitedWidget from '../../../widgets/manageProhibitedWidget/ManageProhibitedWidget'
import { getMasterReservedWord } from '../../../redux/actions/masterReservedWord'

export default function ManageProhibited() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getMasterReservedWord('')
      setSchema(_schema)
      // setSchema(_schema)
      // setIsEditWidget({
      //   projectName: _schema.forms?.projectName?.id ? false : true,
      // })
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load AllProjectSummaryReport')
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <SidebarProposal isManagement>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {schema?.forms && (
        <>
          <ManageProhibitedWidget schema={schema?.forms} />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
